import { useState, useEffect } from 'react'

import { fetchAndActivate, getAll } from 'firebase/remote-config'
import { firebaseRemoteConfig } from 'lib/firebase'

export const useFirebaseRemoteConfig = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(null)

  useEffect(() => {
    fetchAndActivate(firebaseRemoteConfig)
      .then((activated) => {
        if (!activated) {
          console.log('[Firebase][Remote Config] using from cache')
        }

        const allValues = getAll(firebaseRemoteConfig)

        const flags = {
          is_web_subscription_enabled:
            allValues?.is_web_subscription_enabled?.asBoolean(),
        }

        setData(flags)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return { data, isLoading }
}
